import React, { useEffect } from 'react';
import { Modal, Form, Row, Col } from 'antd';
import { Input } from '@/components/form';
import { IUser } from '../../types';
import { useUpdateUser } from '../../hooks';

interface EditPersonalDetailsModalProps {
  open: boolean;
  user: IUser | null;
  onClose: () => void;
  onSuccess: () => void;
}

export const EditPersonalDetailsModal: React.FC<EditPersonalDetailsModalProps> = ({
  open,
  user,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const updateUserMutation = useUpdateUser();

  useEffect(() => {
    if (open && user) {
      form.setFieldsValue({
        firstname: user.firstname || '',
        lastname: user.lastname || '',
        internalemailaddress: user.internalemailaddress || user.domainname || '',
      });
    }
  }, [open, user, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      await updateUserMutation.mutateAsync({
        id: user!.systemuserid,
        payload: {
          firstname: values.firstname,
          lastname: values.lastname,
          internalemailaddress: values.internalemailaddress,
        },
      });

      onSuccess();
      onClose();
    } catch (error) {
    }
  };

  return (
    <Modal
      title="Edit Personal Details"
      open={open}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Save"
      cancelText="Cancel"
      width={600}
      confirmLoading={updateUserMutation.isPending}
    >
      <Form
        form={form}
        layout="vertical"
        className="mt-4"
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Input
              name="firstname"
              label="First Name"
              placeholder="Enter first name"
              required
            />
          </Col>
          <Col xs={24} sm={12}>
            <Input
              name="lastname"
              label="Last Name"
              placeholder="Enter last name"
              required
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24}>
            <Input
              name="internalemailaddress"
              label="Email"
              placeholder="Enter email address"
              type="email"
              required
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditPersonalDetailsModal;
